import { useQueryRefresh } from '../';
import { investmentById } from '../queries';
import { gql } from 'apollo-boost';

const query = gql`
  query ($id: ID) {
    allInvestments(filters: {id: $id}) {
      edges {
          node {
              dbId
              invitation {
              	edges {
              		node {
              			email
              			firstName
              			lastName
              			organization
              		}
              	}
              }
          }
      }
    }
  }
`;


export function useInvestmentById(id) {
  const { data, refresh, isLoading } = useQueryRefresh(investmentById, { id });
  return { data, refresh, isLoading };
}

export function useInvestmentInvitation(id) {
  if (!id) return { data: {} };
  const { data, refresh, isLoading } = useQueryRefresh(query, { id });
  // gets first investment invitation
  const invitation = data?.allInvestments?.edges?.[0]?.node?.invitation?.edges?.[0]?.node;
  return { data: invitation, refresh, isLoading };
}

const investmentDatesQuery = gql`
  query ($id: ID) {
    allInvestments(filters: {id: $id}) {
      edges {
        node {
          reportDate1,
          reportDate2,
          reportDate3,
          reportDate4,
          reportDate5,
          reportDate6,
          timelineDays1,
          timelineDays2,
          timelineDays3,
          timelineDays4,
          timelineDays5,
          timelineDays6,
          timelineFrom1,
          timelineFrom2,
          timelineFrom3,
          timelineFrom4,
          timelineFrom5,
          timelineFrom6
        }
      }
    }
  }
`;

export function useInvestmentDates(id) {
  const { data, refresh, isLoading } = useQueryRefresh(investmentDatesQuery, { id }, [], true, !id);
  return {
    data: data?.allInvestments?.edges?.[0]?.node,
    refresh,
    isLoading
  };
}
